import { readonly, ref } from 'vue'

/**
 * Call function on every `requestAnimationFrame`. With control of canceling
 */
export default function useAnimationFrame (fn, options = {}) {
    const {
        immediate = true,
        fpsLimit = undefined,
    } = options

    const isActive = ref(false)
    const intervalLimit = fpsLimit ? 1000 / fpsLimit : null
    let previousFrameTimestamp = 0
    let rafId = null

    function loop (timestamp) {
        if (!isActive.value || !window)
            return

        if (!previousFrameTimestamp)
            previousFrameTimestamp = timestamp

        const delta = timestamp - previousFrameTimestamp

        if (intervalLimit && delta < intervalLimit) {
            rafId = window.requestAnimationFrame(loop)
            return
        }

        previousFrameTimestamp = timestamp
        fn({ delta, timestamp })
        rafId = window.requestAnimationFrame(loop)
    }

    function resume() {
        if (!isActive.value && window) {
            isActive.value = true
            previousFrameTimestamp = 0
            rafId = window.requestAnimationFrame(loop)
        }
    }

    function pause() {
        isActive.value = false
        if (rafId != null && window) {
            window.cancelAnimationFrame(rafId)
            rafId = null
        }
    }

    if (immediate) {
        resume()
    }

    return {
        isActive: readonly(isActive),
        pause,
        resume,
    }
}
